import { Swiper, SwiperSlide } from 'swiper/react';
import { format } from "date-fns";
import { ru } from "date-fns/locale";
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import { FreeMode, Scrollbar, Navigation } from 'swiper/modules';
import { Link } from 'react-router-dom';
import { ImageLoader } from '../UI/ImageLoader';
import { Button, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from 'react';
import { Clock } from 'react-bootstrap-icons';

//format(new Date(item.startOfEvent), 'dd.MM')} 
export const DateBtn = ({ schedule }) => {
    const date = new Date(schedule.startOfEvent);
    

    return (
        <Link to={`/paytickets/session?sessionsId=${schedule.sessionTPId}`} className='text-decoration-none'>
            <div>
                <div className="border border-1 shadow-sm rounded pt-1 pb-1 pe-4 ps-4 text-center afisha-date-btn">
                    {/* Время */}
                    <div className="d-flex gap-1">
                        <div classname="text-dark">
                            {format(date, 'dd', { locale: ru })}
                        </div>
                        <div className='text-muted'>
                            {format(date, 'MMM', { locale: ru }).replace(".", "")}
                        </div>
                    </div>
                    <div className='text-muted' style={{ fontSize: '0.65rem', fontWeight: '600', margin: '2px 0' }}>
                    </div>
                    {/* Дата + месяц */}

                    <div>
                        {/* День недели */}
                        {/* <div className='text-center' style={{ fontSize: '0.55rem', fontWeight: '600', letterSpacing: '0.8px', textTransform: 'uppercase' }}>
                            {format(date, 'EEEEEE', { locale: ru }).toUpperCase()}
                        </div> */}
                        <div className='text-muted' style={{ fontSize: '0.75rem', fontWeight: '500' }}>
                            {format(date, 'HH:mm')}
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    );
};

export const AfishaSlider = ({ items }) => {
    const [t] = useTranslation("global");
    const refImg = useRef(null);
    const sizeSlider = () => {
        const itemsSize = items.length
        const result = {
            '@0.00': {
                slidesPerView: itemsSize > 1 ? 1.2 : itemsSize, // 2 полный + 0.2 частично видимого
                centeredSlides: false,
                spaceBetween: 20,
            },
            '@0.75': {
                slidesPerView: itemsSize > 1 ? 1.4 : itemsSize, // 1 полный + 0.5 частично видимого
                centeredSlides: false,
                spaceBetween: 30,
            },
            '@1.00': {
                slidesPerView: itemsSize > 3 ? 3.2 : itemsSize, // 2 полных + 0.2 частично видимого третьего
                centeredSlides: false,
                spaceBetween: 30,
            },
            '@1.50': {
                slidesPerView: itemsSize > 3 ? 4.2 : itemsSize, // 2 полных + 0.3 частично видимого третьего
                centeredSlides: false,
                spaceBetween: 40,
            },
            '@2.00': {
                slidesPerView: itemsSize > 3 ? 4.2 : itemsSize, // 2 полных + 0.4 частично видимого третьего
                centeredSlides: false,
                spaceBetween: 50,
            },
        }
        return result
    }

    useEffect(() => {
        console.log(refImg)
    }, [refImg])

    return (
        <Swiper
            slidesPerView={'auto'}
            spaceBetween={30}
            scrollbar={true}
            navigation={true}
            modules={[Scrollbar, FreeMode, Navigation]}
            className="afisha-swiper justify-content-center"
            breakpoints={sizeSlider()}
            // Добавляем отступ слева, чтобы первый слайд не прилипал к краю
            slidesOffsetBefore={items.length > 2 ? 20 : 0}
            slidesOffsetAfter={items.length > 2 ? 20 : 0}

        >
            {items.map((item) =>
                <SwiperSlide key={item.name} className='mb-3 afisha-swiper-slide'>
                    <div className='position-relative' >
                        {items.length > 1 ?
                            <div style={{ maxWidth: '400px', inset: 0, margin: 'auto' }}>
                                <Link to={`/about-project/show/${item.seoUrl}`} className='link-decor'>
                                    {/* <div style={{ minHeight: "60px" }} className='d-flex align-items-end'>
                                        <h4 className='afisha-event-title mb-0 d-none d-md-block'>{item.name}</h4>
                                        <h4 className='afisha-event-title mb-0 d-md-none'>{item.name}</h4>
                                    </div> */}
                                    <div className='position-relative text-center'>
                                        <ImageLoader ref={refImg} src={`https://leningradcenter.ru/api/shows/afisha-img/${item.id}`} name={item.name} mHeight={'65vh'} />
                                    </div>
                                    <div className='afisha-event-desc mt-0 mb-1 ms-1' style={{ fontSize: "0.75rem" }}>{item.description}</div>
                                </Link>
                                <div className='d-flex align-items-end'>
                                    <h4 className='afisha-event-title mb-0 d-none d-md-block'>{item.name}</h4>
                                    <h4 className='afisha-event-title mb-0 d-md-none'>{item.name}</h4>
                                </div>
                                <Row className='justify-content-lg-around mt-1 mb-1'>
                                    <Col>
                                        <div
                                            className='text-center d-flex justify-content-center align-content-center gap-2'
                                            style={{
                                                borderRight: "1px solid",
                                                borderRightColor: "#764ba246",
                                                borderRightWidth: "1px",
                                                // lineHeight: 1.2
                                            }}
                                        >{item.ageCategory}+</div>
                                    </Col>
                                    <Col className='text-center flex-wrap d-flex justify-content-center align-content-center'>
                                        {item.showSchedules[0] &&
                                            <div
                                                className='text-center d-flex justify-content-center align-content-center gap-2 flex-fill'
                                                style={{
                                                    // color: '#764ba2',
                                                    borderRight: "1px solid",
                                                    borderRightColor: "#764ba246",
                                                    borderRightWidth: "1px",
                                                    lineHeight: 1.2
                                                }}
                                            ><Clock /> {item.showSchedules[0].duration} мин</div>
                                        }
                                    </Col>
                                    <Col className='text-center flex-wrap d-flex justify-content-center align-content-center'>
                                        <div
                                            style={{
                                                lineHeight: 1.2
                                            }}
                                            className='text-center text-nowrap d-flex justify-content-center align-content-center gap-2 flex-fill'
                                        >
                                            <svg width={16} height={16}>
                                                <use xlinkHref='lc-logo.svg#stage'></use>
                                            </svg>
                                            Основная сцена</div>
                                    </Col>
                                </Row>
                                <div className='mt-1 mt-1'>
                                    <p className="mb-0"
                                        style={{
                                            color: "#764ba2",
                                            // lineHeight: 0
                                        }}
                                    >Выберите дату</p>
                                    <Row>
                                        {item.showSchedules.map((date) =>
                                            <Col sm={4}>
                                                <DateBtn schedule={date} />
                                            </Col>
                                        )}
                                    </Row>
                                </div>
                            </div>
                            :
                            <>
                                <Row>
                                    <Col>
                                        <Link to={`/about-project/show/${item.seoUrl}`} className='link-decor'>
                                            <div className='position-relative text-center'>
                                                <div className='d-md-none'>
                                                    <ImageLoader src={`/api/shows/afisha-img/${item.id}`} name={item.name} mHeight={'60vh'} />
                                                </div>
                                                <div className='d-none d-md-block'>
                                                    <ImageLoader src={`/api/shows/head-img/${item.id}`} wide={true} name={item.name} mHeight={'70vh'} />
                                                </div>
                                            </div>
                                        </Link>
                                    </Col>
                                    <Col lg={4}>
                                        <Link to={`/about-project/show/${item.seoUrl}`} className='link-decor'>
                                            <h3 className='afisha-event-title mt-3 mb-0'>
                                                <strong>{item.name}</strong>
                                            </h3>
                                            <Row className='justify-content-lg-around mt-1 mb-1'>
                                                <Col>
                                                    <div
                                                        className='text-center d-flex justify-content-center align-content-center gap-2'
                                                        style={{
                                                            borderRight: "1px solid",
                                                            borderRightColor: "#764ba246",
                                                            borderRightWidth: "1px",
                                                            // lineHeight: 1.2
                                                        }}
                                                    >{item.ageCategory}+</div>
                                                </Col>
                                                <Col className='text-center flex-wrap d-flex justify-content-center align-content-center'>
                                                    {item.showSchedules[0] &&
                                                        <div
                                                            className='text-center d-flex justify-content-center align-content-center gap-2 flex-fill'
                                                            style={{
                                                                // color: '#764ba2',
                                                                borderRight: "1px solid",
                                                                borderRightColor: "#764ba246",
                                                                borderRightWidth: "1px",
                                                                lineHeight: 1.2
                                                            }}
                                                        ><Clock /> {item.showSchedules[0].duration} мин</div>
                                                    }
                                                </Col>
                                                <Col className='text-center flex-wrap d-flex justify-content-center align-content-center'>
                                                    <div
                                                        style={{
                                                            lineHeight: 1.2
                                                        }}
                                                        className='text-center text-nowrap d-flex justify-content-center align-content-center gap-2 flex-fill'
                                                    >
                                                        <svg width={16} height={16}>
                                                            <use xlinkHref='lc-logo.svg#stage'></use>
                                                        </svg>
                                                        Основная сцена</div>
                                                </Col>
                                            </Row>
                                            <div className='mt-1 mt-1'>
                                                <p className="mb-0"
                                                    style={{
                                                        color: "#764ba2",
                                                        // lineHeight: 0
                                                    }}
                                                >Выберите дату</p>
                                                <Row>
                                                    {item.showSchedules.map((date) =>
                                                        <Col sm={4}>
                                                            <DateBtn schedule={date} />
                                                        </Col>
                                                    )}
                                                </Row>
                                            </div>
                                        </Link>
                                    </Col>
                                </Row>
                            </>
                        }
                    </div>
                </SwiperSlide>
            )}
        </Swiper>
    )
}